import { render, staticRenderFns } from "./videoDraft.vue?vue&type=template&id=8ffbc9ac&scoped=true"
import script from "./videoDraft.vue?vue&type=script&lang=js"
export * from "./videoDraft.vue?vue&type=script&lang=js"
import style0 from "./videoDraft.vue?vue&type=style&index=0&id=8ffbc9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffbc9ac",
  null
  
)

export default component.exports